<template>
  <p v-bind="$attrs" class="tw-text-xs tw-text-neutral-400">
    <slot />
  </p>
</template>

<script setup></script>
